/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(document).ready(function(){

                  $('.nav-mobile-controller').click(function(){

                     if( $('body').hasClass('mobile-nav-show') ) {
                        $('body').removeClass('mobile-nav-show');
                     }else{
                        $('body').addClass('mobile-nav-show');
                     }

                  });

                  $('body').on('click', '.search-icon',function(){

                      if( $('body').hasClass('show-search-box') ) {
                        $('body').removeClass('show-search-box');
                     }else{
                        $('body').addClass('show-search-box');
                     }         

                  });

                  $('body').on('click','.search-submit-button',function(){
                      $(this).closest('form').submit();
                  });


                  $('.bla-filters-container a').click(function(e){
                    e.preventDefault();
                    var bla_filters_container = $(this).closest('.bla-filters-container');
                    var taxonomy = $(this).attr('data-type');
                    var slug = $(this).attr('data-name');
                    var name = $(this).text();
                    if( $(this).hasClass('selected') ){
                      $(this).removeClass('selected');
                      $(bla_filters_container).find('.filter-capture .filter-capture-taxonomy[data-taxonomy="'+taxonomy+'"][data-term-slug="'+slug+'"]').remove();
                    }else{
                      var filter_capture_html = Handlebars.compile( $('.handlebar-templates #filter-capture-item').html() );
                      var fc_array = {
                        'taxonomy': taxonomy,
                        'slug': slug,
                        'name': name
                      };
                      $(bla_filters_container).find('.filter-capture').append(filter_capture_html(fc_array));
                      $(this).addClass('selected');
                    }

                  });
  
                  $('body').on('click','.filter-capture-taxonomy .filter-ct-del', function (){
                      var data_type = $(this).closest('.filter-capture-taxonomy').attr('data-taxonomy');
                      var data_name = $(this).closest('.filter-capture-taxonomy').attr('data-term-slug')
                      var bla_filter_container_a = $('a[data-type="'+data_type+'"][data-name="'+data_name+'"]');
                      $(bla_filter_container_a).removeClass('selected');
                      $(this).closest('.filter-capture-taxonomy').remove();
                  });

                  $('.bla-filters-container .filter-button').click(function(){
                    // how many in filter-capture
                    var bla_filters_container = $(this).closest('.bla-filters-container');
                    var filters_capture = $(bla_filters_container).find('.filter-capture');
                    var filter_applied = $(filters_capture).find('.filter-capture-taxonomy').length;
                    
                    if( filter_applied > 1 ){

                        var filters_to_apply = {}
                        
                        $.each( $(filters_capture).find('.filter-capture-taxonomy'), function( k, v ){
                            var taxonomy = $(v).attr('data-taxonomy');
                            var slug = $(v).attr('data-term-slug');
                            if( typeof filters_to_apply[taxonomy] == 'undefined' ){
                              filters_to_apply[taxonomy] = [];
                            }
                            filters_to_apply[taxonomy].push(slug);
                        });

                        var taxonomy_keys = Object.keys( filters_to_apply );
                        taxonomy_keys.sort();
                        var url_parameters = [];
                        $.each( taxonomy_keys, function (k,v){
                          var v_string = 'filter-'+v+'='+filters_to_apply[v].sort().join(',');
                          url_parameters.push(v_string);
                        });
                        var destination_url = $(this).find('input[name="filter-destination"]').val();

                        if( destination_url.indexOf('&') >= 0 || destination_url.indexOf('?') >= 0 ){
                          document.location = destination_url+'&'+url_parameters.join('&');
                        }else{
                          document.location = destination_url+'?'+url_parameters.join('&');
                        }

                    }else if( filter_applied == 1 ){

                      var taxonomy = $(filters_capture).find('.filter-capture-taxonomy').attr('data-taxonomy');
                      var slug = $(filters_capture).find('.filter-capture-taxonomy').attr('data-term-slug');
                      if( typeof $(bla_filters_container).find( 'a[data-type="'+taxonomy+'"][data-name="'+slug+'"]' )[0] !== 'undefined' ){
                        document.location = $(bla_filters_container).find( 'a[data-type="'+taxonomy+'"][data-name="'+slug+'"]' ).attr('href');
                      }
                    
                    }

                  });
    
                  $('.bla-filter-title').click(function(){
                      if( $(this).closest('.bla-filter-container').hasClass('active') ){
                         $(this).closest('.bla-filter-container').removeClass('active');
                      }else{
                        $(this).closest('.bla-filter-container').addClass('active');
                      }
                  });

        });
        
        function top_page_init(){
          if( $('body').hasClass('no-header') ){
            return;
          }
          var curr_top = $(window).scrollTop();
          var header_top = ( $('header').position().top + $('header').height() ) / 2;

          if( curr_top <= header_top ){
            $('body').addClass('top-page');
          }else{
            $('body').removeClass('top-page');
          }       
    
        }

        top_page_init();

        $(window).scroll(function(event) {
        
          top_page_init();
        
        });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
